import bodybuilder from 'bodybuilder'
import * as ReduxObservable from 'redux-observable'
import * as Menu from '../../../components/menu'
import * as Elasticsearch from '../../../elasticsearch'
import * as Router from '../../../router'
import * as Constants from './constants'

const fetchSession: ReduxObservable.Epic<any, any, any> = (action$, store, {history}) =>
  action$.ofType(Constants.FetchOnboardingSessions.success)
    .map(store.getState)
    .mergeMap((state: any) => state.onboardingSessions.sessions
      .map(({sessionId}: any) =>
        Elasticsearch.createEsSearch(Constants.FETCH_ONBOARDING_SESSION)
        (
          state.app.selectedCommunity,
          Elasticsearch.Indexes.UserEvents,
          bodybuilder()
            .size(5000)
            .sort('timestamp', 'asc')
            .filter(
              'term',
              Elasticsearch.keyword(Elasticsearch.DocumentFieldNames.SessionId),
              sessionId,
            ).build())))

const fetchSessions: ReduxObservable.Epic<any, any, any> = (action$, store, {history}) =>
  action$.ofType(Router.ON_ENTER, Constants.save)
    .filter(() => history.location.pathname === Menu.REPORTS_ONBOARDING_SESSIONS)
    .map(store.getState)
    .map((state: any) =>
      Elasticsearch.createEsSearch(Constants.FETCH_ONBOARDING_SESSIONS)
      (
        state.app.selectedCommunity,
        Elasticsearch.Indexes.UserEvents,
        bodybuilder().size(0)
          .filter(
            'range',
            'timestamp',
            {
              gte: state.onboardingSessions.form.fields.timeWindowStart,
              lte: state.onboardingSessions.form.fields.timeWindowEnd,
            },
          )
          .aggregation(
            'terms',
            Elasticsearch.keyword(Elasticsearch.DocumentFieldNames.SessionId),
            'sessions',
          ).build()))

export const epic = ReduxObservable.combineEpics(fetchSessions, fetchSession)



// WEBPACK FOOTER //
// ./src/pages/reports/onboarding-sessions/epic.ts